"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeDateTimeSection = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../styled/styles");
var DateRangeTimeSection_1 = require("./DateRangeTimeSection");
var DateRangeUtils_1 = require("../utils/DateRangeUtils");
var core_1 = require("@blueprintjs/core");
var DateRangeDateTimeSection = function (props) {
    var _a, _b, _c, _d;
    var onShortcutChange = props.onShortcutChange, selectedShortcutIndex = props.selectedShortcutIndex, shortcuts = props.shortcuts, minTime = props.minTime, maxTime = props.maxTime, dateType = props.dateType, disabled = props.disabled, state = props.state, onChangeDate = props.onChangeDate, onChangeTime = props.onChangeTime, startTimeProps = props.startTimeProps, endTimeProps = props.endTimeProps, useAmPm = props.useAmPm, precision = props.precision, dayPickerProps = props.dayPickerProps, allowSingleDayRange = props.allowSingleDayRange, boundary = props.boundary, onHoverChange = props.onHoverChange;
    var _e = DateRangeUtils_1.DateRangeUtils.transformState(state), startDate = _e.startDate, startTime = _e.startTime, endDate = _e.endDate, endTime = _e.endTime;
    var onDayClick = function (day, modifiers, e) {
        var _a, _b;
        var dateToSend = boundary === core_1.Boundary.START ? [day, endDate] : [startDate, day];
        (_b = (_a = props === null || props === void 0 ? void 0 : props.dayPickerProps) === null || _a === void 0 ? void 0 : _a.onDayClick) === null || _b === void 0 ? void 0 : _b.call(_a, day, modifiers, e);
        onChangeDate(dateToSend);
    };
    return (react_1.default.createElement(styles_1.DateRangeDateTimeSectionBody, { dateType: dateType },
        react_1.default.createElement(styles_1.DateRangePickerStyled, { value: [startDate, endDate], dayPickerProps: __assign(__assign({}, dayPickerProps), { onDayClick: onDayClick, fixedWeeks: true }), boundaryToModify: boundary, maxDate: maxTime, minDate: minTime, onShortcutChange: onShortcutChange, selectedShortcutIndex: selectedShortcutIndex, shortcuts: shortcuts, disabled: disabled, allowSingleDayRange: allowSingleDayRange, onHoverChange: onHoverChange }),
        dateType === 'DATETIME' && (react_1.default.createElement(styles_1.DateRangeTimeSectionDateTimeBody, null,
            react_1.default.createElement(DateRangeTimeSection_1.DateRangeTimeSection, { startTime: {
                    value: startTime,
                    onChange: onChangeTime('START'),
                    useAmPm: (_a = startTimeProps === null || startTimeProps === void 0 ? void 0 : startTimeProps.useAmPm) !== null && _a !== void 0 ? _a : useAmPm,
                    precision: (_b = startTimeProps === null || startTimeProps === void 0 ? void 0 : startTimeProps.precision) !== null && _b !== void 0 ? _b : precision
                }, endTime: {
                    value: endTime,
                    onChange: onChangeTime('END'),
                    useAmPm: (_c = endTimeProps === null || endTimeProps === void 0 ? void 0 : endTimeProps.useAmPm) !== null && _c !== void 0 ? _c : useAmPm,
                    precision: (_d = endTimeProps === null || endTimeProps === void 0 ? void 0 : endTimeProps.precision) !== null && _d !== void 0 ? _d : precision
                }, disabled: disabled })))));
};
exports.DateRangeDateTimeSection = DateRangeDateTimeSection;
